import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'laoDate',
  pure: false, // Make it impure to react to language changes
  standalone: true
})
export class LaoDatePipe implements PipeTransform {

  constructor(private translateService: TranslateService) {}

  transform(value: any, format?: string): string {
    if (!value) return '';

    const date = new Date(value);
    if (isNaN(date.getTime())) return '';

    const currentLang = this.translateService.currentLang || 'lo';

    if (currentLang === 'lo') {
      return format === 'full' ? this.formatLaoDateTimeFull(date) : this.formatLaoDate(date);
    } else {
      return format === 'full' ? this.formatEnglishDateTimeFull(date) : this.formatEnglishDate(date);
    }
  }

  private formatLaoDate(date: Date): string {
    const day = date.getDate();
    const month = date.getMonth();
    const year = date.getFullYear();

    // Lao month abbreviations
    const laoMonths = [
      'ມ.ກ.',   // January
      'ກ.ພ.',   // February
      'ມ.ນ.',   // March
      'ມ.ສ.',   // April
      'ພ.ພ.',   // May
      'ມ.ຖ.',   // June
      'ກ.ຄ.',   // July
      'ສ.ຫ.',   // August
      'ກ.ຍ.',   // September
      'ຕ.ລ.',   // October
      'ພ.ຈ.',   // November
      'ທ.ວ.'    // December
    ];

    return `${day} ${laoMonths[month]} ${year}`;
  }

  private formatLaoDateTimeFull(date: Date): string {
    const day = date.getDate();
    const month = date.getMonth();
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    // Lao month abbreviations
    const laoMonths = [
      'ມ.ກ.',   // January
      'ກ.ພ.',   // February
      'ມ.ນ.',   // March
      'ມ.ສ.',   // April
      'ພ.ພ.',   // May
      'ມ.ຖ.',   // June
      'ກ.ຄ.',   // July
      'ສ.ຫ.',   // August
      'ກ.ຍ.',   // September
      'ຕ.ລ.',   // October
      'ພ.ຈ.',   // November
      'ທ.ວ.'    // December
    ];

    return `${day} ${laoMonths[month]} ${year} ${hours}:${minutes}`;
  }

  private formatEnglishDate(date: Date): string {
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    };

    return date.toLocaleDateString('en-US', options);
  }

  private formatEnglishDateTimeFull(date: Date): string {
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    };

    return date.toLocaleString('en-US', options);
  }
}